import { CalendarDays } from 'lucide-react';
import { todayLocalISO } from '@/lib/dates';

/**
 * A document's date (invoice, collection) on SellGo's own database: today
 * unless a manager / supervisor dates it back (written up late) or ahead.
 */
export default function DocDateField({ label, value, onChange }) {
  const today = todayLocalISO();
  const note = value < today ? 'هيتسجّل بتاريخ قديم' : value > today ? 'هيتسجّل بتاريخ مستقبلي' : '';

  return (
    <div className="bg-card border border-border rounded-2xl p-3">
      <div className="flex items-center justify-between gap-3">
        <label htmlFor="doc-date" className="text-xs text-muted-foreground flex items-center gap-1.5">
          <CalendarDays className="w-3.5 h-3.5" /> {label}
        </label>
        {value !== today && (
          <button type="button" onClick={() => onChange(today)} className="text-xs text-primary font-semibold">
            رجّعه للنهارده
          </button>
        )}
      </div>
      <input id="doc-date" type="date" value={value} min="2000-01-01" max={todayLocalISO(366)}
        onChange={e => { if (e.target.value) onChange(e.target.value); }}
        className="mt-2 w-full h-10 rounded-xl border border-border bg-background px-3 text-sm font-semibold text-foreground" />
      {note && <p className="text-[11px] font-semibold text-amber-600 mt-1">{note}</p>}
    </div>
  );
}
